import {Icon20MessageOutline} from "@vkontakte/icons";
import {Button} from "@vkontakte/vkui";
import React from "react";
import {useSnackbar} from "../../context/SnackbarContext";
import {openTelegramShare} from "../../services/telegramWebApp";

export const InviteButton = () => {
    const {showSuccessSnackbar, showErrorSnackbar} = useSnackbar();

    const inviteButtonHandler = () => {
        const isOpened = openTelegramShare({
            text: "Join Wordmania in Telegram",
            url: "https://t.me",
        });

        if (!isOpened) {
            showErrorSnackbar("Failed to send invite");
            return;
        }

        showSuccessSnackbar("Invite dialog opened");
    }

    return (
        <Button
            appearance={'overlay'}
            className={"rounded bg-yellow-400 hover:bg-yellow-500 text-gray-800 border-solid border-2 border-yellow-400/20"}
            size={"m"}
            before={<Icon20MessageOutline/>}
            onClick={inviteButtonHandler}>
            Invite a friend
        </Button>
    );
};
